const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path fill-rule="evenodd" d="M6.25 4.9A2.15 2.15 0 0 1 8.4 2.75h7.2a2.15 2.15 0 0 1 2.15 2.15v14.2a2.15 2.15 0 0 1-2.15 2.15H8.4a2.15 2.15 0 0 1-2.15-2.15zm2.15-.65a.65.65 0 0 0-.65.65v.85h8.5V4.9a.65.65 0 0 0-.65-.65zm7.85 3h-8.5v9.5h8.5zM7.75 19.1v-.85h8.5v.85a.65.65 0 0 1-.65.65H8.4a.65.65 0 0 1-.65-.65" clip-rule="evenodd"/></svg>';
export {
  e as w
};
